// ══════════════════════════════════════════════════════════════
// COMPASS – Notification (In-App Feed) Actions
// ══════════════════════════════════════════════════════════════
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Notification } from './notification.model';

export const NotificationActions = createActionGroup({
  source: 'Notification',
  events: {
    // Background refresh lifecycle
    'Start Background Refresh': emptyProps(),
    'Stop Background Refresh': emptyProps(),

    // Bell refresh (/history — used for both badge count + panel list)
    'Refresh Bell': emptyProps(),
    'Refresh Bell Success': props<{ items: Notification[] }>(),
    'Refresh Bell Failure': props<{ error: string }>(),

    // Bell open -> /poll (server-side mark-as-read) then refresh bell
    'Open Bell Menu': emptyProps(),
    'Poll Success': props<{ items: Notification[] }>(),
    'Poll Failure': props<{ error: string }>(),

    // Reset
    'Clear Notifications': emptyProps(),
  },
});
